import { render, staticRenderFns } from "./It.vue?vue&type=template&id=1841ab81&scoped=true&"
import script from "./It.vue?vue&type=script&lang=js&"
export * from "./It.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841ab81",
  null
  
)

export default component.exports